import { BUSINESS_UNIT } from '@/constants/businessUnit'
import { isTestEnvironment, getLocalBusinessUnit } from '@/utils/envUtils'

export const businessUnit = (hostname: string) => {
  if (isTestEnvironment()) return getLocalBusinessUnit()

  switch (true) {
    case hostname?.includes('gbpt'):
      return BUSINESS_UNIT.GBPT
    case hostname?.includes('vdbot'):
      return BUSINESS_UNIT.VDBOT
    case hostname?.includes('gb'):
      return BUSINESS_UNIT.GB
    default:
      return BUSINESS_UNIT.GB
  }
}

export const theme = (hostname: string) => {
  const currentBU = businessUnit(hostname)

  const themeMap: Record<string, string> = {
    GB: 'gb',
    GBPT: 'gbpt',
    VDBOT: 'venda-direta'
  }

  return themeMap[currentBU || BUSINESS_UNIT.GB]
}
